import {Component, Input, OnInit} from '@angular/core';
import {Article} from '../../../../../../../domain/publications/model/article';
import {AmplitudeService} from '../../../../../../../application/analytics/service/amplitude.service';

@Component({
             selector: 'app-widget-publication-article-item',
             templateUrl: './home-dashboard-widget-publication-article-item.component.html',
             styleUrls: ['./home-dashboard-widget-publication-article-item.component.scss']
           })
export class HomeDashboardWidgetPublicationArticleItemComponent implements OnInit {

  @Input() article: Article;
  @Input() publicationUrl: string;
  @Input() accountId: string;
  @Input() widgetName: string;
  @Input() trackAction: string;

  articleUrl: string;

  constructor(private amplitudeService: AmplitudeService) {
  }

  ngOnInit(): void {
    this.articleUrl = this.publicationUrl
                          .concat(`/${this.article.categoryUid}`)
                          .concat(`/${this.article.subcategoryUid}`)
                          .concat(`/${this.article.uid}`)
                          .concat(`?source=Portal&accountId=${this.accountId}`);
  }

  onClickTrackAction() {
    const eventProperties = new Map<string, string>();
    eventProperties.set('Action', this.trackAction);
    eventProperties.set('Titre', this.article.title);
    eventProperties.set('URL', this.articleUrl);
    eventProperties.set('Catégorie', this.article.categoryUid);
    eventProperties.set('Sous catégorie', this.article.subcategoryUid);

    this.amplitudeService.trackEventProperties(this.trackAction, eventProperties);
  }
}
